angular.module('impactx.dashboard').controller('EditDashboardCtrl', [
    '$scope',
    'dataGen',
    'ColorUtilService',
    '$errorHandler',
    '$routeParams',
    '$mdDialog',
    'ToastService',
    'TranslationService',
    '$window',
    'BackService',
    'ToolbarService',
    'MinWidthService',
    EditDashboardCtrl]);

function EditDashboardCtrl($scope, dataGen, ColorUtilService, $errorHandler, $routeParams, $mdDialog, ToastService,
                           TranslationService, $window, BackService, ToolbarService, MinWidthService) {
    $scope.grids = [];
    var self = this;
    var numberOfSetElements = 0;

    dataGen.getData($scope, {comId: $routeParams.comId}, "/dashboard/edit/view").then(function () {
        $scope.buttonDefinition = [
            {label: $scope.trns.save, action: self.saveDashBoard, type: 'dialogaction'},
            {label: $scope.trns.addGrid, action: self.addGrid, type: 'dialogaction'},
            {label: $scope.trns.addFullWidthGrid, action: self.addFullWidthGrid, type: 'dialogaction'}
        ];
        ToolbarService.setButtons($scope.buttonDefinition);
        if ($scope.data.gridList.grids.length > 0) {
            for (var i = 0; i < $scope.data.gridList.grids.length; i++) {
                var gridDefinition = $scope.data.gridList.grids[i];
                if (!gridDefinition.fullWidth) {
                    var grid = [];
                    for (var k = 0; k < gridDefinition.numberOfRows; k++) {
                        grid[k] = [];
                        for (var j = 0; j < gridDefinition.numberOfColumns; j++) {
                            grid[k][j] = {};
                        }
                    }
                    self.convertItemsToGrid(grid, gridDefinition.gridElements, gridDefinition.numberOfRows, gridDefinition.numberOfColumns);
                    $scope.grids.push({grid: grid, elementList: self.collectItems(grid), id: gridDefinition.id});
                    self.checkForMaxNumberOfColumns();
                }
                else {
                    gridDefinition.fullWidthElement.color = ColorUtilService.getColor(0);
                    $scope.grids.push(gridDefinition);
                }
            }
        }
    });

    var internalId = 1;

    self.addElement = function (event, columnPosition, rowPosition, gridObject) {
        var grid = gridObject.grid;
        $mdDialog.show({
            controller: "AddDashboardElementCtrl",
            controllerAs: "addDashboardElementCtrl",
            templateUrl: 'modules/dashboard/templates/dashboard.addelement.tmpl.html',
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                trns: $scope.trns,
                columnPosition: columnPosition,
                rowPosition: rowPosition,
                numberOfColumns: grid[0].length,
                numberOfRows: grid.length,
                availablePanels: JSON.parse(JSON.stringify($scope.data.availablePanels))
            }
        }).then(function (addedElement) {
            for (var i = addedElement.columnPosition; i < addedElement.columnPosition + addedElement.width; i++) {
                for (var j = addedElement.rowPosition; j < addedElement.rowPosition + addedElement.height; j++) {
                    if (grid[j][i].panel) {
                        var toReplaceElement = grid[j][i];
                        for (var k = toReplaceElement.columnPosition; k < toReplaceElement.columnPosition + toReplaceElement.width; k++) {
                            for (var l = toReplaceElement.rowPosition; l < toReplaceElement.rowPosition + toReplaceElement.height; l++) {
                                grid[l][k] = {};
                            }
                        }
                    }
                }
            }
            addedElement.internalId = internalId++;
            for (var i = addedElement.columnPosition; i < addedElement.columnPosition + addedElement.width; i++) {
                for (var j = addedElement.rowPosition; j < addedElement.rowPosition + addedElement.height; j++) {
                    grid[j][i] = addedElement;
                }
            }
            gridObject.elementList = self.collectItems(grid);
            numberOfSetElements++;
        });
    };

    self.collectItems = function (grid) {
        var elements = [];
        var handledInternalIds = [];
        var numberOfSetElements = 0;
        for (var i = 0; i < grid.length; i++) {
            var row = grid[i];
            for (var j = 0; j < row.length; j++) {
                var element = row[j];
                if (element.internalId) {
                    if (handledInternalIds.indexOf(element.internalId) < 0) {
                        element.color = ColorUtilService.getColor(numberOfSetElements++);
                        elements.push(element);
                        handledInternalIds.push(element.internalId);
                    }
                }
            }
        }
        return elements;
    };

    self.convertItemsToGrid = function (grid, elements, numberOfRows, numberOfColumns) {
        self.makeClearGrid(grid, numberOfRows, numberOfColumns);
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            element.internalId = internalId++;

            for (var k = element.rowPosition; k < element.rowPosition + element.height; k++) {
                for (var j = element.columnPosition; j < element.columnPosition + element.width; j++) {
                    grid[k][j] = element;
                }
            }
        }
    };

    self.makeClearGrid = function (grid, numberOfRows, numberOfColumns) {
        for (var i = 0; i < numberOfRows; i++) {
            grid[i] = [];
            for (var j = 0; j < numberOfColumns; j++) {
                grid[i][j] = {};
            }
        }
    };

    self.saveDashBoard = function () {
        var gridList = {};
        gridList.grids = [];
        for (var i = 0; i < $scope.grids.length; i++) {
            if (!$scope.grids[i].fullWidth) {
                var grid = $scope.grids[i].grid;
                gridList.grids.push({
                    gridElements: self.collectItems(grid),
                    numberOfRows: grid.length,
                    numberOfColumns: grid[0].length,
                    id: $scope.grids[i].id
                });
            }
            else {
                gridList.grids.push($scope.grids[i]);
            }

        }

        var dataObj = {
            comId: $routeParams.comId,
            gridList: gridList
        };
        return dataGen.postAsForm({}, dataObj, "/dashboard/edit/save").then(function () {
            if ($routeParams.comId > 0) {
                BackService.back();
            }
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    self.addGrid = function (event) {
        $mdDialog.show({
            controller: "AddDashboardGridCtrl",
            controllerAs: "addDashboardGridCtrl",
            templateUrl: 'modules/dashboard/templates/dashboard.addgrid.tmpl.html',
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                trns: $scope.trns
            }
        }).then(function (options) {
            var grid = [];
            self.makeClearGrid(grid, options.height, options.width);
            $scope.grids.push({grid: grid});
            self.checkForMaxNumberOfColumns();
        });
    };

    self.addFullWidthGrid = function (event) {
        $mdDialog.show({
            controller: "AddFullWidthGridCtrl",
            controllerAs: "addFullWidthGridCtrl",
            templateUrl: 'modules/dashboard/templates/dashboard.addfullwidthgrid.tmpl.html',
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                trns: $scope.trns,
                availablePanels: JSON.parse(JSON.stringify($scope.data.availablePanels))
            }
        }).then(function (addedElement) {
            addedElement.color = ColorUtilService.getColor(0);
            $scope.grids.push({fullWidth: true, fullWidthElement: addedElement});
        });
    };

    self.deleteElement = function (gridObject, element) {
        gridObject.elementList.splice(gridObject.elementList.indexOf(element), 1);
        self.convertItemsToGrid(gridObject.grid, gridObject.elementList, gridObject.grid.length, gridObject.grid[0].length);
    };

    self.editExternalContent = function (event, element, fullWidth) {
        $mdDialog.show({
            controller: "EditExternalContentCtrl",
            controllerAs: "editExternalContentCtrl",
            templateUrl: 'modules/dashboard/templates/dashboard.editexternalcontent.tmpl.html',
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                trns: $scope.trns,
                element: element,
                fullWidth: fullWidth
            }
        }).then(function () {

        });
    };

    self.deletePanel = function (gridObject) {
        $scope.grids.splice($scope.grids.indexOf(gridObject), 1);
        self.checkForMaxNumberOfColumns();
    };

    self.moveUp = function (gridObject) {
        var currentIndexInArray = $scope.grids.indexOf(gridObject);
        $scope.grids.splice(currentIndexInArray, 1, $scope.grids[currentIndexInArray - 1]);
        $scope.grids.splice(currentIndexInArray - 1, 1, gridObject);
    };

    self.moveDown = function (gridObject) {
        var currentIndexInArray = $scope.grids.indexOf(gridObject);
        $scope.grids.splice(currentIndexInArray, 1, $scope.grids[currentIndexInArray + 1]);
        $scope.grids.splice(currentIndexInArray + 1, 1, gridObject);
    };

    self.checkForMaxNumberOfColumns = function () {
        var maxNumberOfColumns = 0;
        for (var i = 0; i < $scope.grids.length; i++) {
            var grid = $scope.grids[i].grid;
            if (!$scope.grids[i].fullWidth) {
                if (grid.length > 0) {
                    if (grid[0].length > maxNumberOfColumns) {
                        maxNumberOfColumns = grid[0].length;
                    }
                }
            }
        }
        var offSetCorrection = 250 + 250 + 32;
        if (maxNumberOfColumns * 175 + offSetCorrection > 1230) {
            MinWidthService.setSpecialMinWidthForDialog($scope, maxNumberOfColumns * 175 + offSetCorrection);
        }
    };
}